import './client-credentials.modal.scss';

export default function ClientCredentialsModal ($scope, close, credentials, $alert, $t) {
  'ngInject';

  $scope.credentials = credentials;

  $scope.credentials.copyClientId = () => {
    navigator.clipboard.writeText($scope.credentials.clientId);
    $alert.success($t('admin.applications.info.client_id_copied_successfully'))
  }

  $scope.credentials.copyClientSecret = () => {
    navigator.clipboard.writeText($scope.credentials.clientSecret);
    $alert.success($t('admin.applications.info.client_secret_copied_successfully'))
  }

  $scope.close = () => {
    close();
  }
}